import { render, staticRenderFns } from "./AdminPanelButton.vue?vue&type=template&id=71c1322d&scoped=true&"
import script from "./AdminPanelButton.vue?vue&type=script&lang=js&"
export * from "./AdminPanelButton.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelButton.vue?vue&type=style&index=0&id=71c1322d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1322d",
  null
  
)

export default component.exports